
import React from 'react';
import { Link } from 'react-router-dom';
import NavBarLinks from './NavBarLinks';
import { useScreenSize } from '@/hooks/use-mobile';
import logoImage from '@/assets/followthesun-logo.png';

const NavBar = () => {
  const { isMobile } = useScreenSize();

  return (
    <header className="z-50 glass-card border-b border-border/50 w-full">
      <div className="container flex items-center justify-between h-14 sm:h-16 px-3 sm:px-4 md:px-6">
        <Link 
          to="/" 
          className="flex items-center space-x-2 sm:space-x-3 group transition-all duration-300 hover-lift"
        >
          <img 
            src={logoImage} 
            alt="FollowTheSun" 
            className="w-6 h-6 sm:w-7 sm:h-7 group-hover:animate-glow transition-all duration-300" 
          />
          <span className={`font-bold text-gradient-sunset ${isMobile ? 'text-lg' : 'text-xl'}`}>
            FollowTheSun
          </span>
        </Link>
        <NavBarLinks />
      </div>
    </header>
  );
};

export default NavBar;
